<template>
  <task-list :client-id="clientId" :hideTitle="true" />
</template>

<script>
import TaskList from "src/views/Pages/TaskList";
export default {
  props: {
    clientId: Number,
  },

  components: {
    TaskList,
  },

  methods: {
    async refresh() {
    },
  },

};
</script>